<template>
    <div id="app">
        <Header/>
        <Survey class="my-4"/>
        <Footer class="my-4"/>
    </div>
</template>
<style lang="scss">
    @import "assets/scss/app.scss";
</style>
<script>

    import Header from './components/Header';
    import Survey from './components/Survey';
    import Footer from './components/Footer';
    export default {
        name: 'app',
        components: {
            Footer,
            Survey,
            Header,
        },
    };
</script>
